var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat_action"},[_c('input',{attrs:{"type":"image","src":"static/images/chat/chat_bubble.svg","alt":"Submit"},on:{"click":function($event){$event.preventDefault();_vm.chat()}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ba4a18","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/shared/ChatBubble.vue
// module id = null
// module chunks = 